import { useTranslator } from '@bluebeam/react-i18n';
import { BannerContext } from 'components/Routes/BannerContext';
import AppStoreContext from 'contexts/AppStoreContext';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { getDaysRemaining } from 'utils/format';

const ClosedProjectBanner = (): ReactElement => {
  const globalState = useContext(AppStoreContext);
  const { setHeight } = useContext(BannerContext);
  const { state } = globalState;
  const [isLoaded, setIsLoaded] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);
  const { translate } = useTranslator(['roverDashboard']);

  const bannerRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (bannerRef.current) {
      setHeight(bannerRef.current.getBoundingClientRect().height);
    }

    return () => {
      setHeight(0);
    };
  }, [bannerRef.current]);

  const project = state.projects.get(state.selectedProject);

  let trialExp = '';
  if (project) {
    trialExp = `${daysRemaining} day${daysRemaining > 1 ? 's' : ''}`;
  }

  const bannerText = () => {
    if (!isLoaded) {
      return '';
    }

    return daysRemaining <= 0
      ? translate('roverDashboard:viewOnlyAccess')
      : translate('roverDashboard:viewOnlyCountdown', {
          trialExp,
        });
  };

  return (
    <div
      className="row justify-center items-center w100 py3 bb-2 bgd-section"
      ref={bannerRef}
      style={{ height: '52px' }}
    >
      {bannerText()}
    </div>
  );
};

export default ClosedProjectBanner;
